import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import IncentivePresenter from "./IncentivePresenter";
import BaseListPage from "../../../base/BaseListPage";
import { InfiniteScroll, Button, dialog } from "nq-component";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";

class IncentivePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      objects: [],
      selected: [],
      limit: 10,
      current: 1,
      count: 0,
    };
    this.presenter = new IncentivePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "incentive";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async handleAddIncentive() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  async _handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute("incentive", id);
    await this.presenter.deleteObjectUseCase.execute("pay_items", id);
    this.refetchData();
    dialog.close();
  }

  handleDeleteData(data) {
    dialog.fire({
      html: (
        <>
          <div className="text-center p-2">
            <i
              className="bi bi-question-circle text-danger"
              style={{ fontSize: "80px" }}
            ></i>

            <h5>Are you sure want to delete this record?</h5>
            <div className="mt-2 mb-3">
              <button
                className="btn btn-primary me-2"
                onClick={() => this._handleDeleteData(data.id)}
              >
                Confirm
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
            </div>
          </div>
        </>
      ),
      footer: false,
    });
  }

  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async generateCSV() {
    await this.presenter.getGenerateCSV();
  }

  render() {
    const { objects, loading, selected, count, limit, current } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} ReferenceTable {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center  justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <Button onClick={this.handleAddIncentive.bind(this)}>
                        <i className="bi bi-plus-lg" /> Add Incentives
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={this.generateCSV.bind(this)}
                      >
                        Export CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                selectable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      // case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(IncentivePage);
